// extracted by mini-css-extract-plugin
export default {"logo":"styles_logo__BkCkN","noLanguageToggle":"styles_noLanguageToggle__fVoEc","fullView":"styles_fullView__pQYfd","shimmer":"styles_shimmer__EXQIS"};